import React from 'react'
import request from 'superagent'
import R from 'ramda'

import {AUTH_API_URL} from '_constants'

import SerialInfo from '_views/serialInfo'

const getSerial = R.path(['license', 'activated_info', 'serial_id'])

class SerialUpgrade extends React.PureComponent {
  state = {
    serial: null
  }
  componentDidMount () {
    if (this.state.serial) return
    const serial = getSerial(this.props)
    if (!serial) {
      return
    }
    const url = `${AUTH_API_URL}/serials/${serial}`
    request.get(url)
      .withCredentials()
      .set('Content-Type', 'application/json')
      .accept('json')
      .end((err, res) => {
        if (err || R.has('error', R.prop('body', res))) {
          return console.error(err)
        }
        this.setState({serial: R.path(['body'], res)})
      })
  }
  render () {
    return this.state.serial
      ? (<div><SerialInfo serial={R.prop('serial', this.state)} /></div>)
      : (<div>Loading ... {getSerial(this.props)}</div>)
  }
}

export default SerialUpgrade



// WEBPACK FOOTER //
// ./webAdmin/views/license/serial.js